import * as e from 'express';
import { FormGroupState, unbox } from 'ngrx-forms';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { Ente } from '@ideapa/app-shared-ente';
import { RoleCode, SUPER_ENTE_CODE } from '@ideapa/common-utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap/modal';

import { AuthFacade } from '../../+state/auth.facade';
import {
  SelectModuloFormValue,
  SelectModuloPartecipataFormValue,
} from '../../+state/auth.reducer';

@Component({
  standalone: false,
  templateUrl: './select-modulo-modal.container.html',
  styleUrls: ['./select-modulo-modal.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectModuloModalContainer implements OnInit {
  @Input()
  enti!: Ente[];

  entiForSelect!: Ente[];

  @Input()
  showWarning = true;

  form$ = this.authFacade.selectModuloForm$;
  formPartecipata$ = this.authFacade.selectModuloPartecipataForm$;
  loggedUser$ = this.authFacade.selectLoggedUser$;
  RoleCode = RoleCode;

  constructor(
    private authFacade: AuthFacade,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.entiForSelect = this.enti
      .map((e) => ({
        ...e,
        description: e.codice + ' - ' + e.descrizione,
      }))
      .filter((e) => e.codice !== SUPER_ENTE_CODE)
      .sort((c1, c2) => {
        return c1.descrizione > c2.descrizione ? 1 : -1;
      });
  }

  onSubmit(form: FormGroupState<SelectModuloFormValue>) {
    if (form.isValid) {
      this.activeModal.close({
        ente: unbox(form.value.ente),
        anno: form.value.anno,
      });
    }
  }

  onSubmitP(form: FormGroupState<SelectModuloPartecipataFormValue>) {
    if (form.isValid) {
      this.activeModal.close({
        anno: form.value.anno,
      });
    }
  }

  cancel() {
    this.activeModal.close();
  }
}
